Array.prototype.shuffle = function() {
  var i = this.length, j, temp;
  if ( i == 0 ) return this;
  while ( --i ) {
     j = Math.floor( Math.random() * ( i + 1 ) );
     temp = this[i];
     this[i] = this[j];
     this[j] = temp;
  }
  return this;
};

$(document).ready(function() {
  
  // Menu dropdown hack voor iPhone etc
  $('.navbar-toggle').click(function(){ });

  // Kolom links
  $('.kolom a').each(function(){
    $(this).prepend('<span class="fa fa-chevron-right"></span>');
  });


  // Collapse
  $('.text .collapse').each(function(index){
    $(this).attr('href','#collapse-'+index).attr('data-toggle','collapse').prepend('<span class="fa fa-chevron-right closed"></span><span class="fa fa-chevron-down open"></span>');
    $(this).removeClass('collapse').addClass('collapse-button collapsed');
    var next = $(this).nextUntil(this.nodeName);
    $(next).addClass('collapse').attr('id','collapse-'+index);
  });


  // Koppen
  var koppen = $('.main .text h1.icoon').add('.main .text h2.icoon');
  var ikoon_kleuren = ['blauw-groen','blauw-paars','groen-paars'];
  while (koppen.length > ikoon_kleuren.length) {
    ikoon_kleuren = ikoon_kleuren.concat(ikoon_kleuren);
  }
  ikoon_kleuren.shuffle();
  ikoon_kleuren = ikoon_kleuren.slice(0,koppen.length);
  $(koppen).each(function(){
    var ikoon_nr = rand(18);
    var ikoon = 'icoon-'+ikoon_kleuren.shift()+'-'+ikoon_nr;
    $(this).addClass(ikoon);
    $(this).prepend('<div class="inner-icoon" style="background-image:url(\'assets/img/'+ikoon+'.svg\');"></div>');
  });


  // Achtergrond
  $('.achtergrond').each(function(){
    var kleuren = ['blauw','groen','paars'];
    kleuren = shuffle(kleuren);

    var nr = rand(8)+1;
    $(this).append('<div class="achtergrond-item achtergrond-links achtergrond-links-'+nr+' large"><img src="assets/img/achtergrond-'+kleuren.shift()+'-'+nr+'-links.svg"></div>');
    nr = rand(8)+1;
    $(this).append('<div class="achtergrond-item achtergrond-rechts achtergrond-rechts-'+nr+' large"><img src="assets/img/achtergrond-'+kleuren.shift()+'-'+nr+'-rechts.svg"></div>');
  });

});

$(window).load(function() {
});

$(window).resize(function() {
});

function rand(max) {
  return Math.ceil(Math.random()*max);
}

function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;
  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}



//
// Minimal jQuery plugin template, for more comments see template.js (which has essentially the same template as the one here)
//
(function($) {
  var defaults = {};
  var opts;
  var self;
  var methods = {
    init : function( options ) {
      self=this;
   		opts = $.extend({}, defaults, options);
      //
      // (Initialise) code here...
      //
      return self;
    }
    // Put more methods here
  };
  $.fn.PLUGIN_NAME = function(methodOrOptions) {
     if ( methods[methodOrOptions] ) {
       return methods[ methodOrOptions ].apply( this, Array.prototype.slice.call( arguments, 1 ));
     } else if ( typeof methodOrOptions === 'object' || ! methodOrOptions ) {
       return methods.init.apply( this, arguments );
     } else {
       $.error( 'Method "' +  methodOrOptions + '" does not exist on jQuery.PLUGIN_NAME' );
     }    
   };  
})(jQuery);






